import axios from "./AxiosService";

const endpoint = "MemberTelephone";
const headers = {
  headers: {
    "Content-Type": "application/json"
  }
};

export default class MemberTelephoneService {
  GetMemberTelephoneNumbers(membershipNumber) {
    return axios
      .get(
        endpoint,
        {
          params: { membershipNumber: membershipNumber }
        },
        headers
      )
      .then((response) => {
        return response.data;
      });
  }

  UpdateMemberTelephoneNumbers(membershipNumber, telephoneModel) {
    const telephone = {
      AreaCode: telephoneModel.AreaCode,
      IntlCode: telephoneModel.IntlCode,
      LocalNumber: telephoneModel.LocalNumber,
      Type: telephoneModel.Type
    };

    return axios
      .post(
        endpoint,
        { MembershipNumber: membershipNumber, telephone },
        headers
      )
      .then((response) => {
        return response.data;
      });
  }

  DeleteMemberTelephoneNumber(membershipNumber, type) {
    return axios
      .delete(endpoint, { params: { membershipNumber, type } }, headers)
      .then((response) => {
        return response.data;
      });
  }
}
